import type {
  CogInputPropertySchema,
  CogInputSchema,
  CogOutputSchema,
  CogTrainingInputSchema,
  OpenapiSchema,
} from "./types";

export interface ObjectWithSchema {
  dereferenced_openapi_schema: OpenapiSchema;
}

export function getInputSchema(obj: ObjectWithSchema): CogInputSchema {
  return obj.dereferenced_openapi_schema.components.schemas.Input;
}

export function getTrainingInputSchema(
  obj: ObjectWithSchema
): CogTrainingInputSchema | undefined {
  return obj.dereferenced_openapi_schema.components.schemas.TrainingInput;
}

export function getSortedProperties(
  inputSchema: CogInputSchema | CogTrainingInputSchema
): [string, CogInputPropertySchema][] {
  return Object.entries(inputSchema.properties).sort(
    ([, a], [, b]) => a["x-order"] - b["x-order"]
  );
}

export function isFile(property: CogInputPropertySchema): boolean {
  return (
    "type" in property &&
    property.type === "string" &&
    property.format === "uri"
  );
}

export function getFileProperties(inputSchema: CogInputSchema): string[] {
  const fileInputs: string[] = [];
  for (const [name, property] of Object.entries(inputSchema.properties)) {
    if (isFile(property)) {
      fileInputs.push(name);
    }
  }
  return fileInputs;
}

export function getOutputSchema(obj: ObjectWithSchema): CogOutputSchema {
  return obj.dereferenced_openapi_schema.components.schemas.Output;
}
